import React, { useEffect, useState } from "react";
import "./resetPassword.css";
import logo from "../../assets/logo.png";
import show from "../../assets/show.png";
import hide from "../../assets/hide.png";
import { ClipLoader } from "react-spinners";
import { Link } from "react-router-dom";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import emailSent from "../../assets/email_sent.png";
import passwordResetedIcon from "../../assets/password_reseted.png";

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [token, setToken] = useState("");
  const [loading, setLoading] = useState("");
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [linkSent, setLinkSent] = useState(false);
  const [passwordReseted, setPasswordReseted] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const sendLink = async () => {
    try {
      setLoading(true);
      setError("");
      const isValidEmail = emailPattern.test(email);

      if (!isValidEmail) {
        setError("Please enter a valid email address.");
        return;
      }

      await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/member/send-password-reset-email`,
        {
          email,
        }
      );

      setLinkSent(true);
    } catch (error) {
      setError(error.response.data.message);
    } finally {
      setLoading("");
    }
  };

  const resetPassword = async () => {
    try {
      setError(null);
      setLoading(true);

      if (password === "" || confirmPassword === "") {
        setError("Please enter both password and confirm password values.");
        return;
      } else if (password.length < 8) {
        setError("Password must be longer than 8 characters.");
        return;
      } else if (password !== confirmPassword) {
        setError("Passwords must match.");
        return;
      }

      await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/member/reset-password`,
        {
          token: token,
          newPassword: password,
        }
      );

      setPasswordReseted(true);
    } catch (error) {
      setError(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tokenToSet = searchParams.get("token");
    setToken(tokenToSet);
  }, []);

  return (
    <div className="login-page-container">
      <div className="login-header-div">
        <img className="login-header-img" src={logo} />
      </div>

      {!token ? (
        <>
          {linkSent ? (
            <div className="login-form-div">
              <img className="reset-password-img" src={emailSent} />
              <h1 className="login-form-h">Email sent</h1>
              <p className="login-form-p">Please check your inbox.</p>

              <div
                onClick={() => {
                  window.open("https://www.gmail.com", "_blank");
                }}
                className="login-form-button"
              >
                Open Gmail
              </div>
            </div>
          ) : (
            <div className="login-form-div">
              <h1 className="login-form-h">Forgot password?</h1>
              <p className="login-form-p">
                No worries, we will send you link to reset it.
              </p>

              <input
                name="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                className="regular-input mb-16"
                placeholder="Email"
                type="email"
              />

              <div
                onClick={loading === true ? null : sendLink}
                className="login-form-button"
              >
                {loading === true ? (
                  <ClipLoader size={20} color={"#fff"} />
                ) : (
                  "Send"
                )}
              </div>
              {error && <p className="login-form-error-p">{error}</p>}
            </div>
          )}
        </>
      ) : (
        <>
          {passwordReseted ? (
            <div className="login-form-div">
              <img
                className="reset-password-img mb-16"
                src={passwordResetedIcon}
              />
              <h1 className="login-form-h">Password Reseted</h1>
              <p className="login-form-p">Click below to go to login screen.</p>

              <Link to={"/login"} className="login-form-button">
                Login
              </Link>
            </div>
          ) : (
            <div className="login-form-div">
              <h1 className="login-form-h">Set new password</h1>
              <p className="login-form-p">
                Make sure that the new password is different from the previous.
              </p>

              <div className="password-input-div mb-16">
                <input
                  name="password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  className="regular-input"
                  placeholder="Password"
                  type={showPassword ? "text" : "password"}
                />
                <img
                  onClick={() => {
                    setShowPassword((prevState) => !prevState);
                  }}
                  className="password-input-icon"
                  src={showPassword ? hide : show}
                />
              </div>

              <div className="password-input-div">
                <input
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                  }}
                  className="regular-input"
                  placeholder="Confirm Password"
                  type={showConfirmPassword ? "text" : "password"}
                />
                <img
                  onClick={() => {
                    setShowConfirmPassword((prevState) => !prevState);
                  }}
                  className="password-input-icon"
                  src={showConfirmPassword ? hide : show}
                />
              </div>

              <div
                onClick={loading === true ? null : resetPassword}
                className="login-form-button"
              >
                {loading === true ? (
                  <ClipLoader size={20} color={"#fff"} />
                ) : (
                  "Reset"
                )}
              </div>
              {error && <p className="login-form-error-p">{error}</p>}
            </div>
          )}
        </>
      )}

      <div className="login-dont-div">
        <Link to={"/login"} className="login-dont-div-link">
          Back to login
        </Link>
      </div>
    </div>
  );
};

export default ResetPassword;
